module.exports = __webpack_public_path__ + "static/media/tree-menu-icon.c7d9c3f6.svg";